export const API_DEFAULT_HEADERS = { 'Content-Type': 'application/json' };